/**
 * One listing tile's placeholder — the square photo and the price plate under
 * it, at the dimensions the loaded tile occupies.
 *
 * Mirrors `components/listing-thumb.tsx` element for element, so the tile's own
 * stylesheet (`.listing`, `.listing-image`, `.listing-image-cont`,
 * `.listing-price` in styles/components/listing.scss) produces the boxes rather
 * than a guess:
 *
 *   .listing        301 x 359   (in the browse grid at 1440px)
 *   .listing-image  301 x 301   square, from `.listing-image-cont`'s aspect-ratio
 *   .listing-price  301 x 58    min-height, title line + price row
 *
 * Because the geometry is inherited, the same component is correct in the browse
 * grid (`.listing-cont`, auto-fill columns) and in a showcase strip
 * (`.product-list-item`, a fixed 300px / 185px on mobile) without being told
 * which one it is in.
 *
 * The bars stand in for text, so they hold a non-breaking space and take their
 * container's own line box — 1.5rem for the title, 1.6rem for the price. Block
 * rather than inline-block, which would add a descender to the line.
 *
 * Two line boxes stacked flush read as one lumpy block, so the price bar sits
 * 8px below the title. The loaded tile has that gap too: its price is set far
 * larger than the title. Title, gap and price still come in under the plate's
 * 58px min-height, so the tile keeps its height when it loads.
 */
const ListingTileSkeleton = () => (
  <div className="listing">
    <div className="listing-image relative">
      <div className="listing-image-cont skeleton" />
    </div>
    <div className="listing-price">
      <div className="title">
        <div className="skeleton skeleton-scope rounded-md block w-4/5">
          &nbsp;
        </div>
      </div>
      <div className="font-bold mt-2">
        <div className="skeleton skeleton-scope rounded-md block w-16">
          &nbsp;
        </div>
      </div>
    </div>
  </div>
);

export default ListingTileSkeleton;
